import { NumberPadConstants } from './numberPad.constants'

export const defaultNumberOfItemsPerRow = 3

export const digitKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', NumberPadConstants.EMPTY, '0']

export const numberPadKeysWithDecimal = ['.']

export const phoneNumberKeys = ['-']

export const ssnKeys = ['-']

export const zipCodeKeys = ['-']

export const diastolicBPKeys = ['P']

export const geoLocationKeys = ['.', '-']

export const hyphenDotKeys = ['-', '.']

export const allSpecialChars = ['.', '-']

export const reservedWords = [NumberPadConstants.BACKSPACE.toString(), NumberPadConstants.EMPTY.toString()]

export const temperatureKeys = ['-']

export const ratioKey = [':']

export const ratioKeyWithDecimal = [':', '.']
